import _classCallCheck from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import t from "react";
import "prop-types";
import e from "./ViewportManager.js";
import r from "../../utils/isStyledComponent.js";
import o from "./ErrorBoundary.js";
var i = function i(_i) {
  var n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
  var s = _i ? _i.displayName || _i.name : "Component",
    a = "function" == typeof _i && !(_i.prototype && "isReactComponent" in _i.prototype),
    p = r(_i) || a;
  var m = /*#__PURE__*/function (_t$Component) {
    _inherits(m, _t$Component);
    function m(t) {
      var _this;
      _classCallCheck(this, m);
      _this = _possibleConstructorReturn(this, _getPrototypeOf(m).call(this, t)), _this.viewportManager = e, _this.state = {
        viewport: void 0
      }, _this.id = _this._makeid(10);
      return _this;
    }
    _createClass(m, [{
      key: "_makeid",
      value: function _makeid(t) {
        for (var e = "", r = 0; r < t; r++) {
          var _t = Math.random(),
            _r = Math.floor(10 * _t);
          e += "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789".charAt(_r);
        }
        return e;
      }
    }, {
      key: "componentDidMount",
      value: function componentDidMount() {
        var _this2 = this;
        this.setState({
          viewport: n ? this.viewportManager.viewport.expandedViewport : this.viewportManager.viewport.normalViewport
        }), this.viewportManager.subscribe(this.id, n, function (t) {
          _this2.setState({
            viewport: t
          });
        });
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        this.viewportManager.unsubscribe(this.id);
      }
    }, {
      key: "render",
      value: function render() {
        var e = Object.assign({
          viewport: this.state.viewport
        }, this.props);
        return p || (e.ref = e.innerRef, delete e.innerRef), t.createElement(o, null, t.createElement(_i, Object.assign({}, e)));
      }
    }]);
    return m;
  }(t.Component);
  return m.displayName = "WithManager(".concat(s, ")"), m;
};
export { i as default };